<template>
  <el-card style="margin-bottom: 50px">
    <div class="add-goods-container">
      <hm-step
        :scroll="true"
        :steps="steps"
        @scroll="windowScroll"
        :step="currentStep"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="组合商品货号：">
              <el-input
                size="small"
                class="mr10 ipt"
                v-model.trim="ruleForm.goods"
                placeholder="不填系统将自动生成"
              ></el-input>
              <div class="form-item-tip">
                用于商家内部管理使用，唯一编码，具体规则由商家定义
              </div>
            </el-form-item>
            <el-form-item label="组合商品条码：">
              <el-input
                size="small"
                class="mr10 ipt"
                v-model.trim="ruleForm.goods"
                placeholder="不填系统将自动生成"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="商品类目："
              class="is-required"
              prop="category"
            >
              <el-cascader
                v-model="ruleForm.categoryId"
                :show-message="isShowCategoryErr"
                :show-all-levels="false"
                size="small"
                :props="categoryFunc"
                clearable
              ></el-cascader>
              <el-button
                class="btn"
                size="small"
                @click="toUrl('MicroShopGoodsCate')"
                icon="hmicon icon-hao"
                >新建类目</el-button
              >
              <div class="form-item-tip">商品类目用于手机端显示商品分类</div>
            </el-form-item>
            <el-form-item label="商品名称：" prop="spuName">
              <el-input
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.spuName"
                placeholder="例如：新生儿礼包7月装"
              ></el-input>
            </el-form-item>
            <el-form-item label="主图：">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :width="750"
                :height="750"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'goodsCenter' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <el-button
                type="primary"
                size="small"
                v-show="!ruleForm.spuMainPic"
                @click="toggleShow"
                >上传</el-button
              >
              <span class="form-tip"
                >（主图仅可设置一张，图片尺寸建议750x750）</span
              >
              <div class="priview" v-if="ruleForm.spuMainPic">
                <img :src="ruleForm.spuMainPic" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
            </el-form-item>
            <div id="specification">2.规格/库存信息</div>
            <el-form-item
              label="添加商品："
              class="is-required"
              prop="combGoodsList"
            >
              <div class="table">
                <div class="table-body">
                  <div class="table-row flex">
                    <div class="flex-1 text-center">商品名称</div>
                    <div class="flex-1 text-center">组合数量</div>
                    <div class="flex-1 text-center">组合售价</div>
                    <div class="flex-1 text-center">可售库存</div>
                    <div class="flex-1 text-center">操作</div>
                  </div>
                  <div
                    class="table-row flex"
                    v-for="(v, i) in ruleForm.combGoodsList"
                    :key="i"
                  >
                    <div class="flex-1 text-center">{{ v.goodsName }}</div>
                    <div class="flex-1 text-center">
                      <el-input
                        size="small"
                        type="text"
                        v-model="v.goodsCount"
                      ></el-input>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        size="small"
                        type="text"
                        v-model="v.goodsCount"
                      ></el-input>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        size="small"
                        type="text"
                        v-model="v.goodsCount"
                      ></el-input>
                    </div>
                    <div class="flex-1 flex flex-center item-center">
                      <div class="minus-wrapper">
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteItem(i)"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex flex-center">
                  <div
                    class="flex item-center pointer add-goods"
                    @click="addCombGoods"
                  >
                    <span class="hmicon icon-hao pointer mr10"></span>
                    <span class="primary">添加商品</span>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="建议零售价：" prop="recommendedRetailPrice">
              <el-input
                size="small"
                class="mr10 ipt"
                @input="filterGt0OrFixed2('recommendedRetailPrice')"
                v-model.trim="ruleForm.recommendedRetailPrice"
                placeholder="请输入零售价"
              ></el-input>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >提交</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      @saveGoods="saveGoods"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
  </el-card>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
export default {
  components: { myUpload, HmStep, HmFilterMicroShopGoods },
  data() {
    const patternCategoryFunc = function(rule, val, callback) {
      if (!this.ruleForm.categoryId.length) {
        this.isShowCategoryErr = true;
        return callback(new Error("请选择属性"));
      }
      this.isShowCategoryErr = false;
      callback();
    }.bind(this);
    const patternFunc = function(rule, val, callback) {
      // this.skuModelList.map(v => {
      //   if (!v) {
      //     return callback(new Error("请选择规格"));
      //   }
      //   callback();
      // });
      callback();
    }.bind(this);
    const patternAttributeFunc = function(rule, val, callback) {
      if (!this.ruleForm.spuAttributeList.length) {
        this.isShowAttributeErr = true;
        return callback(new Error("请选择类目"));
      }
      this.isShowAttributeErr = false;
      callback();
    }.bind(this);
    const patternComgoodsList = function(rule, val, callback) {
      if (!this.ruleForm.combGoodsList.length) {
        return callback(new Error("请添加商品"));
      }
      callback();
    }.bind(this);
    // typeId 父级Id
    // specId 子级Id
    return {
      url: "",
      dialogVisible: false,
      specification: "",
      currentStep: 1,
      allAttr: [],
      steps: [
        {
          name: "添加基本信息",
          id: "base"
        },
        {
          name: "价格/库存信息",
          id: "specification"
        }
      ],
      isShowCategoryErr: true,
      isShowAttributeErr: true,
      scrollHeight: 0,
      skuModelList: [],
      showDetail: false,
      show: false,
      isMininum: true,
      applyCount: 0,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      spuSlideShowPicList: [],
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      selectedIndex: "",
      chargeType: "",
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        multiple: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: data.valueId
              };
            } else {
              params = {
                attributeId: data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      recommendedRetailPrice: "",
      ruleForm: {
        combGoodsList: [],
        stock: "",
        categoryId: [],
        goodsType: "reality",
        supportRefund: "",
        preOrder: "open",
        delayType: "date",
        delayDay: "",
        delayDate: "",
        goodsSn: "",
        limit: -1,
        commentsList: [],
        pasOutlets: "",
        spuBarcode: "",
        spuName: "",
        brandId: "",
        spuAttributeList: [],
        netWeight: "",
        grossWeight: "",
        weightUnit: "g",
        recommendedRetailPrice: "",
        basePrice: "",
        supplierId: "",
        spuMainPic: "",
        spuDetails: "",
        specificationList: [
          {
            specName: "",
            specId: "",
            specModels: []
          }
        ],
        spuPlatFormList: [],
        salesState: "open"
      },
      rules: {
        stock: {
          required: true,
          message: "请输入商品名称",
          trigger: "blur"
        },
        combGoodsList: {
          validator: patternComgoodsList,
          trigger: "blur"
        },
        spuName: {
          required: true,
          message: "请输入商品名称",
          trigger: "blur"
        },
        category: {
          validator: patternCategoryFunc,
          trigger: "change"
        },
        brandId: {
          required: true,
          message: "请选择商品品牌",
          trigger: "change"
        },
        attribute: {
          validator: patternAttributeFunc,
          trigger: "blur"
        },
        recommendedRetailPrice: {
          required: true,
          message: "请输入建议零售价",
          trigger: "blur"
        },
        skuModelList: [
          {
            validator: patternFunc,
            trigger: "change"
          }
        ],
        actMemberUpperLimit: [
          { required: true, message: "请输入活动人数上限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入大于等于0的正整数"));
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters([
    "specList",
    "allBrandList",
    "attrList",
    "supplierList",
    "salesChannels"
  ]),
  watch: {
    "ruleForm.delayType": {
      handler() {
        this.ruleForm.delayDay = "";
        this.ruleForm.delayDate = "";
      },
      deep: true
    },
    "ruleForm.goodsType": {
      handler(val) {
        this.ruleForm.supportRefund = val === "virtual" ? "notSupport" : "";
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("querySpecListByAddGoods");
    this.$store.dispatch("queryBrandAllList", { pageSize: 999999, pageNo: 1 });
    this.$store.dispatch("querySalesChannels");
    // this.$store.dispatch("querySupplierList");
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
      window.addEventListener("resize", this.handleResize, true);
      this.calcHeight();
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    saveGoods() {},
    addCombGoods() {
      this.dialogVisible = true;
    },
    deleteItem(i) {
      this.ruleForm.combGoodsList.splice(i, 1);
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length == 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    importOutSource() {
      // const pattern = /(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
      // if (!pattern.test(this.url)) {
      //   this.$message({
      //     type: "warning",
      //     message: "请输入正确的url！"
      //   });
      // } else {
      // }
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    addSpecification() {
      this.ruleForm.specificationList.push({
        specName: "",
        specId: "",
        specModels: []
      });
    },
    deleteSpecification(v, i) {
      this.skuModelList.forEach(o => {
        o.specValueList.forEach((p, index) => {
          v.attr.map(q => {
            if (p.specId === q.specId) {
              o.specValueList.splice(index, 1);
            }
          });
        });
      });
      this.ruleForm.specificationList.splice(i, 1);
    },
    batchSetting() {
      this.skuModelList.forEach(v => {
        v.recommendedRetailPrice = this.recommendedRetailPrice;
      });
    },
    setAttrList(v, index) {
      let len = this.ruleForm.specificationList.length;
      this.skuModelList = [];
      let resultLen = 1;
      this.ruleForm.specificationList.map(o => {
        resultLen = resultLen * o.attr.length;
      });
      if (len === 1) {
        for (let i = 0; i < resultLen; i++) {
          let specValueList = [];
          specValueList[index] = v.attr[i];
          this.skuModelList.push({
            specValueList,
            specBarcode: "",
            recommendedRetailPrice: ""
          });
        }
      } else if (len === 2) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            let arr2 = [];
            arr2.push(o, p);
            arr.push(arr2);
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            recommendedRetailPrice: ""
          });
        }
      } else if (len === 3) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            this.ruleForm.specificationList[2].attr.map(q => {
              let arr2 = [];
              arr2.push(o, p, q);
              arr.push(arr2);
            });
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            recommendedRetailPrice: ""
          });
        }
      }
    },
    switchSpecification(v, i) {
      const currentRow = this.specList.find(o => o.specId === v.specId);
      this.selectedIndex = i;
      v.attr = [];
      if (currentRow) {
        v.specModels = currentRow.specModels;
        v.specName = currentRow.specName;
      }
    },
    toUrl(url) {
      let routeUrl = this.$router.resolve({
        name: url
      });
      window.open(routeUrl.href, "_blank");
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForm.spuMainPic = jsonData.result;
      } else if (this.showDetail) {
        this.spuSlideShowPicList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.categoryId = params.categoryId.length
            ? params.categoryId[params.categoryId.length - 1]
            : "";
          delete params.specificationList;
          params = Object.assign(params, {
            spuSlideShowPicList: this.spuSlideShowPicList,
            skuModelList: this.skuModelList
          });
          this.$store.dispatch("addGoods", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.spuMainPic = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.ruleForm.spuMainPic = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 750;
        let height = 750;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传750*750的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.spuSlideShowPicList.splice(file, 1);
      } else {
        const index = this.spuSlideShowPicList.findIndex(
          v => v === file.response.result
        );
        this.spuSlideShowPicList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.spuSlideShowPicList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.spuSlideShowPicList[0];
      this.spuSlideShowPicList[0] = this.spuSlideShowPicList[i];
      this.spuSlideShowPicList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="scss">
.add-goods-container {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }
  .btn {
    margin-left: 10px;
    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.title {
  color: #606266;
  font-weight: bold;
  font-size: 14px;
}

.table {
  margin-top: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  .table-control {
    padding: 0 29px;
    border-bottom: 1px solid #ddd;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
    color: #222;
  }
}

.specification-list {
  li {
    padding: 7px 10px;
    margin: 0;
    color: #666;
    background-color: #f8f8f8;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    margin: 20px 0;
  }
}

.priview {
  position: relative;
  width: 250px;
  height: 206px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.add-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  user-select: none;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}

.add-goods {
  user-select: none;
  .hmicon {
    width: 20px;
    height: 20px;
    line-height: 20px;
    padding: 5px;
    font-size: 14px;
    background: #e50065;
    text-align: center;
    border-radius: 50%;
    margin-left: 10px;
    color: #fff;
  }
}
</style>
